import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { UiModalAlertProps } from "../../models/components/modal-alert.model";
import ModalAlertForm from "./ModalAlertForm";

const UiModalAlert = (props: UiModalAlertProps) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			header={t("PARTICIPANTS.ALERTS.MODAL.TITLE")}
			visible={true}
			breakpoints={{ "960px": "75vw", "640px": "100vw" }}
			style={{ width: "70vw" }}
			modal={true}
			focusOnShow={false}
			draggable={false}
			closable={true}
			onHide={props.onCancel}
		>
			<ModalAlertForm
				entity={props.entity}
				onCancel={props.onCancel}
				onComplete={props.onComplete}
			/>
		</Dialog>
	);
};

export default UiModalAlert;
